import { pathToFileURL } from 'node:url';
import path from 'node:path';

const configPath = path.join(process.cwd(), "./postcss.config.js");
// Absolute paths don't work with ESM imports on Windows:
// https://github.com/nodejs/node/issues/31710
// convert it to a file:// URL, which works on all platforms
const configUrl = pathToFileURL(configPath).toString();
const mod = await __turbopack_context__.y(configUrl);

export default mod.default ?? mod;
